var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-center bg-gray20 bd-b-gray80 p-1 p-y-2",class:_vm.isAboutRoot ? 'd-none' : 'd-flex d-none:t',on:{"click":_vm.goToMenu}},[_c('vk-icon',{staticClass:"m-r-1",attrs:{"name":"chevronleft"}}),_c('span',[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }